import { CommonModule } from '@angular/common';
import { Component, inject, input } from '@angular/core';

import { isArray } from '@hglobal/common';
import { TranslateModule } from '@ngx-translate/core';

import { ScrollableShadowComponent, TableComponent } from '@pp/common';
import { GetPaginationRes } from '@pp/core/entities';
import { DictionariesStore } from '@pp/dictionaries';

import { RateInfo } from './rates.entities';

@Component({
  selector: 'pp-rates',
  imports: [CommonModule, TableComponent, TranslateModule, ScrollableShadowComponent],
  templateUrl: './rates.component.html',
  styleUrl: './rates.component.scss',
})
export class RatesComponent {
  readonly #dictionariesStore = inject(DictionariesStore);

  protected readonly isArray = isArray;

  rates = input<GetPaginationRes<RateInfo>>();

  get array(): number[] {
    return Array.from({ length: 5 });
  }

  selectCurrencyByCode(currency: string) {
    return this.#dictionariesStore.selectCurrencyByCode(currency)();
  }
}
